/* libs */
import { createLogic } from "redux-logic";
import axios from "axios";
import firebase from "firebase/app";
import "firebase/auth";

/* action helpers */
import * as ActionTypes from "../../actions/actionTypes";
import * as ThemesActions from "../../actions/themesActions";
import * as constants from "../../constants";

const createThemesLogic = createLogic({
	type: ActionTypes.CREATE_THEME,
	// eslint-disable-next-line no-unused-vars
	process({ getState, action }, dispatch, done) {
		//TODO: dispatch action for creating a loader
		const { appKey, theme } = action;
		firebase
			.auth()
			.currentUser.getIdToken(true)
			.then(token => {
				var api = axios.create({
					baseURL: constants.BASE_API_URL,
					timeout: 20000,
					headers: { Authorization: "Bearer " + token },
				});
				api.post("/themes", theme)
					.then(() => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.createThemeSuccess(appKey));
						done();
					})
					.catch(error => {
						//TODO: dispatch action for stopping loader
						dispatch(ThemesActions.createThemeFailure(error));
						done();
					});
			});
	},
});

export default [createThemesLogic];
